import HTTPService        from "@/js/Shared/Services/HTTP/HTTPService.js";
import HTTPResponseEntity from '@/js/Shared/Services/HTTP/Entities/HTTPResponseEntity.js';
import SAPOMailConfig     from "@/SAPOMailConfig";

export { WizardHTTPService as default };

/**
* Imap Security HTTP Service
*
* @author      rsimoes <ruben-r-simoes@telecom.pt>
* @copyright   Copyright (C) Sapo. All rights reserved.
* @license     Private
* @since       7.0.0
*/
class WizardHTTPService {
  /**
   * Imap Security Enpoint
   *
   * @public
   *
   * @type {string}
   *
   * @since 7.0.0
   */
  endpoint = SAPOMailConfig.client.endpoints.settings.imp;

  /**
   * Makes an HTTP Request to set wizard options to be asked later
   *
   * @public
   *
   * @since 7.0.0
   *
   * @return {Promise.<HTTPResponseEntity>}
   */
  async askLater() {
    let request = {
      op: 'askLater',
    }

    let response = await HTTPService.post(
      this.endpoint + '/wizard',
      request,
      'settings_wizard_ask_later'
    );

    return response;
  }

  /**
   * Makes an HTTP Request to set wizard options to be finished
   *
   * @public
   *
   * @since 7.0.0
   *
   * @return {Promise.<HTTPResponseEntity>}
   */
  async finished() {
    let request = {
      op: 'finished',
    }

    let response = await HTTPService.post(
      this.endpoint + '/wizard',
      request,
      'settings_wizard_finished'
    );

    return response;
  }

  /**
   * Makes an HTTP Request to set wizard options to be finished
   *
   * This endpoint is used to set the flag that controls the display of the "What's New" slide in the wizard
   *
   * @public
   *
   * @since 7.0.0
   *
   * @return {Promise.<HTTPResponseEntity>}
   */
  async whatsNew() {
    let request = {
      op: 'whatsNew',
    }

    let response = await HTTPService.post(
      this.endpoint + '/wizard',
      request,
      'settings_wizard_whats_new'
    );

    return response;
  }
}